// import JSZip from 'jszip';
// import { saveAs } from 'file-saver';
// import { BlobServiceClient } from '@azure/storage-blob';
import { BundleGetDownloadAzureData } from '@/api';
import { azureFileUploadManager } from '@repo/file-uploader';

const splitAzureUrl = (downloadPath: string) => {
  try {
    // Parse the URL into a URL object
    const url = new URL(downloadPath);
    // Extract the base URL (protocol + hostname)
    const baseUrl = `${url.protocol}//${url.hostname}`;
    // Split the pathname into parts and filter out empty segments
    const pathParts = url.pathname.split('/').filter((part) => part !== '');
    // Container name is the first part after the initial '/'
    const containerName = pathParts[0];
    // Blob path is everything after the container name
    const blobPath = pathParts.slice(1).join('/');
    // Extract the file name from the blob path
    const fileName = blobPath.split('/').pop();

    return {
      baseUrl: baseUrl,
      containerName: containerName,
      blobPath: blobPath,
      fileName: fileName
    };
  } catch (error) {
    console.error('Error splitting URL:', error);
    return null;
  }
};

export const downloadFilesAsZip = async (
  urls: BundleGetDownloadAzureData[],
  _zipFileName: string,
  onProgress?: (percent: number | null) => void
) => {
  // const zip = new JSZip();
  const fileCount = urls.length;
  // const progresses = Array(fileCount).fill(0);

  // const updateTotalProgress = () => {
  //   const total = progresses.reduce((sum, p) => sum + p, 0);
  //   const percent = Math.floor(total / fileCount);
  //   if (onProgress) onProgress(percent);
  // };

  // NOTE: Switched to individual downloads to avoid browser crash (OOM) on large bundles.
  // The zipping logic is commented out below.

  // const downloadPromises = urls.map(async ({ downloadPath, downloadToken }, idx) => {
  //   const result = splitAzureUrl(downloadPath);

  //   if (
  //     downloadToken &&
  //     result &&
  //     result.baseUrl?.length &&
  //     result.containerName?.length &&
  //     result.blobPath?.length &&
  //     result.fileName?.length
  //   ) {
  //     try {
  //       const blobServiceClient = new BlobServiceClient(`${result.baseUrl}?${downloadToken}`);
  //       const containerClient = blobServiceClient.getContainerClient(result.containerName);
  //       const blobClient = containerClient.getBlobClient(result.blobPath);

  //       let lastPercent = 0;

  //       const downloadResponse = await blobClient.download(undefined, undefined, {
  //         onProgress: (progress: { loadedBytes: number }) => {
  //           const contentLength = downloadResponse.contentLength ?? 0;

  //           if (contentLength) {
  //             const percent = Math.min(Math.round((progress.loadedBytes / contentLength) * 100), 100);
  //             if (percent !== lastPercent) {
  //               lastPercent = percent;
  //               progresses[idx] = percent;
  //               updateTotalProgress();
  //             }
  //           }
  //         }
  //       });

  //       const blob = await downloadResponse.blobBody;
  //       if (blob) {
  //         zip.file(result.fileName, blob);
  //       }

  //       progresses[idx] = 100;
  //       updateTotalProgress();
  //     } catch (error) {
  //       console.error(`Failed to download file: ${result.fileName}`, error);

  //       progresses[idx] = 100;
  //       updateTotalProgress();
  //     }
  //   } else {
  //     progresses[idx] = 100;
  //     updateTotalProgress();
  //   }
  // });

  // await Promise.all(downloadPromises);

  // const zipBlob = await zip.generateAsync({ type: 'blob' });
  // saveAs(zipBlob, `${zipFileName}.zip`);
  // if (onProgress) onProgress(null);

  // New logic: Download individual files
  let completedCount = 0;
  for (const { downloadPath, downloadToken } of urls) {
    const result = splitAzureUrl(downloadPath);
    if (result && result.fileName && downloadToken) {
      azureFileUploadManager.downloadFile(result.fileName, downloadPath, downloadToken);

      // Update fake progress
      completedCount++;
      const percent = Math.floor((completedCount / fileCount) * 100);
      if (onProgress) onProgress(percent);

      // Small delay to prevent browser blocking/throttling
      await new Promise((resolve) => setTimeout(resolve, 500));
    }
  }

  // Finish
  if (onProgress) onProgress(null);
};
